import { useState } from "react";

// Full logo images - stacked version for centered/large, can be used everywhere
const LOGO_STACKED = "https://customer-assets.emergentagent.com/job_eb6a8b48-0497-4a7c-b249-b9ad87c6c148/artifacts/ece6zfzz_Rating%20Genie%20%286%29.png";
// Horizontal versions for navbars
const LOGO_HORIZONTAL_DARK = "https://customer-assets.emergentagent.com/job_eb6a8b48-0497-4a7c-b249-b9ad87c6c148/artifacts/itfvqpz0_Rating%20Genie%20%285%29.png";
const LOGO_HORIZONTAL_LIGHT = "https://customer-assets.emergentagent.com/job_eb6a8b48-0497-4a7c-b249-b9ad87c6c148/artifacts/wmr5qgac_Rating%20Genie%20%284%29.png";

const Logo = ({ size = "default", theme = "dark" }) => {
  const [imgError, setImgError] = useState(false);

  // Choose image variant based on size and theme
  const imgSrc = size === "large"
    ? LOGO_STACKED
    : theme === "dark"
      ? LOGO_HORIZONTAL_DARK
      : LOGO_HORIZONTAL_LIGHT;

  // Heights per size
  const heights = { small: 28, default: 36, large: 56 };
  const h = heights[size] || 36;

  if (imgError) {
    // Fallback: render text-only logo
    return (
      <div className={`rl-logo rl-logo--${size} rl-logo--${theme}`} data-testid={`logo-${size}-${theme}`}>
        <div className="rl-logo-text">
          <strong>
            Rankify<span className="rl-accent">Local</span>
          </strong>
          <small>Map Dominance Engine</small>
        </div>
      </div>
    );
  }

  return (
    <div className={`rl-logo rl-logo--${size} rl-logo--${theme}`} data-testid={`logo-${size}-${theme}`}>
      <img
        src={imgSrc}
        alt="RankifyLocal"
        onError={() => setImgError(true)}
        style={{ height: h, width: "auto", objectFit: "contain" }}
        className="rl-logo-img"
      />
    </div>
  );
};

export default Logo;
